import {connect} from 'react-redux';

import {savePreferences} from 'mattermost-redux/actions/preferences';
import {shouldShowUnreadCollapsedChannels} from 'mattermost-redux/selectors/entities/preferences';
import {getCurrentUserId} from 'mattermost-redux/selectors/entities/users';

import {GlobalState} from 'types/store';

import ShowUnreadCollapsedChannel from './show_unread_collapsed_channels';

function mapStateToProps(state: GlobalState) {
    return {
        currentUserId: getCurrentUserId(state),
        showUnreadCollapsedChannels: shouldShowUnreadCollapsedChannels(state),
    };
}

const mapDispatchToProps = {
    savePreferences,
};

export default connect(mapStateToProps, mapDispatchToProps)(ShowUnreadCollapsedChannel);
